import { render, staticRenderFns } from "./Admonition.vue?vue&type=template&id=a70fd186"
import script from "./Admonition.vue?vue&type=script&lang=js"
export * from "./Admonition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports